import { useEffect } from 'react'
import { track } from '../lib/pixel'

export function useTrackSection(id: string, name: string, threshold = 0.3) {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const el = document.getElementById(id)
    if (!el) return
    let fired = false
    const observer = new IntersectionObserver(
      (entries) => {
        if (fired) return
        if (entries[0].isIntersecting) {
          fired = true
          track('ViewContent', { content_name: name })
          observer.disconnect()
        }
      },
      { threshold },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [id, name, threshold])
}
